import React, { useState, useEffect } from "react";
import { Container, Row, Col, Modal } from "react-bootstrap";
import { useSelector, useDispatch } from "react-redux";
import { getBlogs } from "store/actions";
import BlogCard from "Pages/blogs/BlogCard";
import Header from "Component/Header/Header";
import Footer from "Component/Footer/Footer";
export default function Blogs(props) {
  const dispatch = useDispatch();
  const { blogs } = useSelector((state) => state?.home);

  useEffect(() => {
    dispatch(getBlogs());
  }, [dispatch]);
  const [youtubeVideo, setyoutubeVideo] = useState();
  const [video, setvideo] = useState(false);

  // const videoData1 = {
  //   title: "How to create your METAMASK account to use on Terpnash NFTs",
  //   description:
  //     "Learn how to set up a Metamask account web browser extension to use on market.terpnash.com for your new NFTs!",
  //   videoLink: "https://www.youtube.com/embed/lWGagLNV_P4?si=J8UbG17t720Zovpr",
  //   imageLink: "/images/png/MetaMaskVideo.png",
  //   date: "29 Sep 2023",
  // };
  // const videoData2 = {
  //   title: "Register an Account on Terpnash NFTs",
  //   description:
  //     "Learn how to register an account on TERPNASH NFTs as a USER or an ARTIST. This process is just to create an account, NOT to submit artwork. If you are an artist you can submit your art once you have registered. ",
  //   videoLink: "https://www.youtube.com/embed/WtHyhFpru_Q?si=-3p4d83jv-4D6br3",
  //   imageLink: "/images/png/registerAccount.png",

  //   date: "29 Sep 2023",
  // };
  // const videoData3 = {
  //   title: "How to Submit Artwork on Terpnash",
  //   blogNumber:3,
  //   description:
  //     "Artist Submissions now open! This video walks through how to submit your original artwork for approval on Terpnash. You will be able to see whether your work has been approved or rejected. ",
  //   videoLink: "https://www.youtube.com/embed/xYXi89WJoTw?si=ayG28W5YKmSzCV8j",
  //   imageLink: "/images/png/submitArtworkonTerpnash.jpg",

  //   date: "17 Nov 2023",
  // };
  const selectApproveArt = (event) => {
    setyoutubeVideo(event);
    setvideo(true);
  };
  const closedialogBox = () => {
    setvideo(false);
  };
  return (
    <>
      <Modal
        className="EmailVerifyBoxModel uploadimg videoBoxDialog text-center"
        show={video}
        centered
        animation={false}
      >
        <div className="dialogHeader px-4 pt-4">
          <div className="text-start">
            <h3 className="mb-1">{youtubeVideo?.title}</h3>
            <p className="mb-0">{youtubeVideo?.discription} </p>
          </div>

          <button onClick={closedialogBox}>
            <i className="fa-regular fa-xmark"></i>
          </button>
        </div>
        <div className="px-4 pb-4">
          <iframe
            src={youtubeVideo?.videoLink}
            title="YouTube video player"
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            allowFullScreen
          ></iframe>
        </div>
      </Modal>
      <div className="position-relative ">
        <Header />
        <div className="gradientBg pb-5">
          <div className="container-fluid profileBox blogbg">
            <Row>
              <Col lg={12}>
                <h1>How To Articles / Videos </h1>
              </Col>
            </Row>
          </div>
          <Container>
            {blogs && blogs?.length > 0 ? (
              <>
                <div
                  className={
                    "DigitalArtcollection-head currentauction-head d-flex align-items-center justify-content-center bloghead py-5"
                  }
                >
                  <div className="text-center">
                    <h2>Digital Artwork Articles</h2>
                    <p>
                      Learn how to get the most from your Digital Artworks. Explore the
                      latest Digital Artworks news and tips and tricks all brought to you by
                      your friendly, talkative Digital Artwork marketplace on BSC.
                    </p>
                  </div>
                </div>
                <Row>
                
                  {blogs?.map((blogsData, idx) => {
                    return (
                      <Col className="mb-3" key={idx} lg={4}>
                        <BlogCard data={blogsData} />
                      </Col>
                    );
                  })}
                </Row>
              </>
            ) : (
              <div className="py-5 w-100">
                <h5 className="collect-head">No Blogs Found !!</h5>
              </div>
            )}
          </Container>
        </div>
        <Footer />
      </div>
    </>
  );
}
